// extracted by mini-css-extract-plugin
export default {"container":"translatableText_container__hltMW","contentRow":"translatableText_contentRow__w8N8K"};